import React, { useState } from "react";
import { Icon } from '@iconify/react';
import { Center, Text, Flex } from '@chakra-ui/react'
import { Link } from "react-router-dom"; 
import CustomButton from "../custom/Button";

type Props = {
  activePage: boolean,
  text: string,
  icon: string,
  linkTarget: string
} 

const NavLink: React.FC<Props> = ({
  activePage, 
  linkTarget, 
  text, 
  icon
}) => {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseEnter = () => setIsHovering(true)
  const handleMouseLeave = () => setIsHovering(false)

  const buttonStyles = {
    width: '170px',
    textAlign: 'left',
    color: 'white',
    borderRadius: '5px',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop: '10px',
    paddingBottom: '10px',
    fontWeight: 'bold',
    fontSize: '18px',
    backgroundColor: activePage || isHovering ? '#37A75B' : 'transparent',
    transition: 'background-color 100ms ease-in'
  };
  return (
    <Center w="100%" h="60px">
      <Link to={linkTarget}>
        <CustomButton
          style={buttonStyles}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Flex alignItems='center' gap='6px'>
            <Icon 
              icon={icon} color="white" 
              width="18" height="18" 
            />

            <Text>{text}</Text>
          </Flex>
        </CustomButton>
      </Link>
    </Center>
  )
}

export default NavLink